import { SettingsParamType, createSettingsParams } from '@wix/tpa-settings';

export type IPaywallSettingsParams = {
  titleHtmlTag: SettingsParamType.String;
};

export type PaywallSettingsParams = ReturnType<typeof createPaywallSettingsParams>;

export function createPaywallSettingsParams() {
  return createSettingsParams<IPaywallSettingsParams>({
    titleHtmlTag: {
      getDefaultValue: () => 'h1',
    },
  });
}

export default createPaywallSettingsParams();

